var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"20px 120px"}},[_c('div',[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 10, maxRows: 10 }},model:{value:(_vm.formula),callback:function ($$v) {_vm.formula=$$v},expression:"formula"}})],1),_c('div',{staticClass:"rendered"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.md.render(_vm.formula))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }